import styled from "styled-components";

export const SelectStyled = styled.div`
  &.dropdown {
    .dropdown-toggle::after {
      transition: all 0.2s;
    }

    &.show {
      .dropdown-toggle::after {
        transform: rotateX(180deg);
      }
    }

    .dropdown-toggle {
      width: 100%;
      padding: 9px 32px 8px 18px;
      text-align: left;
      border: none;
      border-radius: 5px;
      background: #ffffff;
      border: 1px solid #e4e9f0;
      font-family: 'Gotham';
      font-weight: 300;
      font-size: 12px;
      line-height: 15px;
      color: #7a8799;
      white-space: break-spaces;

      &:focus {
        box-shadow: none !important;
      }

      &:active {
        background: #ffffff;
        box-shadow: none;
        border: 1px solid #e4e9f0;
        color: #7a8799;
      }

      &::after {
        border-top: 6px solid;
        border-right: 4px solid transparent;
        border-left: 4px solid transparent;
        right: 17px;
        position: absolute;
        top: 14px;
      }
    }

    .dropdown-menu {
      width: 100%;
      background: #ffffff;
      border-radius: 4px;
      padding: 0;
      border: 1px solid #e4e9f0;
      border-radius: 5px;
      max-height: 270px;
      overflow: auto;

      .dropdown-item {
        padding: 4px 18px;
        outline: 0;
        font-family: 'Gotham';
        font-weight: 300;
        font-size: 12px;
        line-height: 15px;
        color: #7a8799;
        white-space: break-spaces;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .svg-inline--fa.fa-lg {
          width: 10px;
        }

        &.active {
          background: rgb(228, 233, 240);
        }
        &:active {
          color: #7a8799;
          background-color: #fff;
          box-shadow: none;
        }
        &:hover {
          background: rgb(228, 233, 240);
        }
      }
    }
  }
`;
